import {
  IAddToBasketData,
  ICardData,
  IProductCategory,
  IProductSlotPrice,
  IProductTableData,
} from "@/types/db/product-category";
import { IPromocodeCardData } from "@/types/db/promocode-campaign";
import { EmailTypes } from "./booking";
export enum ModalStatus {
  Hidden = "",
  PosConfig = "PosConfig",
  PCSelect = "PCSelect",
  CheckIn = "CheckIn",
  Preferences = "Preferences",
  Products = "Products",
  ProductSelect = "ProductSelect",
  Calculator = "Calculator",
  PaymentCalculator = "PaymentCalculator",
  Orders = "Orders",
  Settings = "Settings",
  Analytics = "Analytics",
  Customers = "Customers",
  CustomerCreate = "CustomerCreate",
  CashierReports = "CashierReports",
  FiscalReports = "FiscalReports",
  DiscountSelectTickets = "DiscountSelectTickets",
  AvailabilityInfo = "AvailabilityInfo",
  SendEmail = "SendEmail",
  PrintTicketsAndReceipt = "PrintTicketsAndReceipt",
  PaymentProgress = "PaymentProgress",
  EditCustomer = "EditCustomer",
  CalendarCardsDay = "CalendarCardsDay",
  DownloadTickets = "DownloadTickets",
  CustomFields = "CustomFields",
  NewCashFloatOpen = "NewCashFloatOpen",
  CashInOut = "CashInOut",
  CashInOutV2 = "CashInOutV2",
  ReloadConfiguration = "ReloadConfiguration",
  OccupancyCalendar = "OccupancyCalendar",
  ScanQrCode = "ScanQrCode",
  Addons = "Addons",
  PromocodeCampaigns = "PromocodeCampaignsModal",
  PromocodeCampaignsTickets = "PromocodeCampaignsTicketsModal",
  TabNameEdit = "TabNameEditModal",
  PromocodeProcessing = "PromocodeProcessing",
  LinkWaiver = "LinkWaiver",
  ShareWaiver = "ShareWaiver",
}

export enum ModalComponents {
  PCSelect = "PCSelect",
  CheckInPage = "CheckInPage",
  POSConfig = "PosConfiguration",
  Preferences = "Preferences",
  Products = "Products",
  ProductSelect = "ProductSelect",
  Calculator = "Calculator",
  PaymentCalculator = "PaymentCalculator",
  Orders = "Orders",
  Settings = "Settings",
  Analytics = "Analytics",
  Customers = "Customers",
  CustomerCreate = "CustomerCreate",
  CashierReports = "CashierReports",
  FiscalReports = "FiscalReports",
  DiscountSelectTickets = "DiscountSelectTickets",
  AvailabilityInfo = "AvailabilityInfo",
  SendEmail = "SendEmail",
  PrintTicketsAndReceipt = "PrintTicketsAndReceipt",
  PaymentProgress = "PaymentProgress",
  EditCustomer = "EditCustomer",
  CalendarCardsDay = "CalendarCardsDay",
  DownloadTickets = "DownloadTickets",
  CustomFields = "CustomFields",
  NewCashFloatOpen = "NewCashFloatOpen",
  CashInOut = "CashInOut",
  ReloadConfiguration = "ReloadConfiguration",
  OccupancyCalendar = "OccupancyCalendar",
  Addons = "Addons",
  PromocodeCampaigns = "PromocodeCampaignsModal",
  PromocodeCampaignsTickets = "PromocodeCampaignsTicketsModal",
  TabNameEdit = "TabNameEditModal",
  PromocodeProcessing = "PromocodeProcessing",
  LinkWaiver = "LinkWaiverModal",
  ShareWaiver = "ShareWaiverModal",
}

export type ModalProps = {
  referrer?: ModalStatus;
  goBack?: boolean;
  props?:
    | AddonsModalProps
    | SendEmailModalProps
    | IPromocodeCardData
    | PCSelectModalProps
    | CheckInModalProps;
};

// The check-in page always works on one order.
export type CheckInModalProps = {
  bookingId: string;
  title?: string;
};

// PCSelect modal props: the tapped card's data is resolved
// from dexie inside the modal
export type PCSelectModalProps = {
  productCategoryId: number;
  timeslotId?: string;
};

// props used by the addons modal
// it is an intersection of the IAddToBasketData interface and {multiple, nextPrices}
// we omit the nonAutomaticAddons and pssQuantity attributes from IAddToBasketData as they are not needed by the modal
export type AddonsModalProps = Omit<
  IAddToBasketData,
  "nonAutomaticAddons" | "pssQuantity"
> & {
  pricesToAddToBasket?: {
    price: IProductSlotPrice;
    pssQuantity: number;
    // Per-unit price override (major units) carried from PCSelect through the
    // addons handoff so an edited price survives PCSelect unmounting (L3-8114).
    overridePrice?: number;
  }[];
};

// props used by the edit or assign customer modal
export type SendEmailModalProps = {
  emailType: EmailTypes;
};
